import { html, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { when } from "@/common/directives/when";
import EkoElement from "@/utilities/element";
import style from "./feed-item.css?inline";

@customElement("eko-feed-item")
class FeedItem extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) href?: string;
  @property({ reflect: true }) target?: "_self" | "_blank" | "_parent" | "_top";

  @property({ attribute: "data-turbo-action", type: String }) turboAction?: string;
  @property({ attribute: "data-turbo-confirm", type: String }) turboConfirm?: string;
  @property({ attribute: "data-turbo-frame", type: String }) turboFrame?: string;
  @property({ attribute: "data-turbo-method", type: String }) turboMethod?: string;

  render() {
    return html`
      <div class="eko-feed-item">
        ${this.href
          ? html`
              <a
                class="eko-feed-item__link"
                data-turbo-action=${when(this.turboAction)}
                data-turbo-confirm=${when(this.turboConfirm)}
                data-turbo-frame=${when(this.turboFrame)}
                data-turbo-method=${when(this.turboMethod)}
                href=${this.href}
                rel=${when(this.target === "_blank", "noopener noreferrer")}
                target=${when(this.target)}>
                <eko-visually-hidden>View more details</eko-visually-hidden>
              </a>
            `
          : nothing}
        <slot class="eko-feed-item__media" name="media"></slot>
        <div class="eko-feed-item__content">
          <div class="eko-feed-item__header">
            <slot class="eko-feed-item__actor" name="actor"></slot>
            <slot class="eko-feed-item__timestamp" name="timestamp"></slot>
          </div>
          <slot></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-feed-item": FeedItem;
  }
}

export default FeedItem;
